import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { getFirstName } from "../../helpers/formatting";
import { withTranslation } from 'react-i18next';

class CustomGraphicsBanner extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //debugger;        
        logUI("MBHWeb.UI.CustomGraphicsBanner.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let { primaryUser, isProxyUser, containerClass, dateTimeOffset, showCustomBanner, isEmployee, versionBannerClass, hasFirstCare, hasMyChartLogin, currentHealthPlanInfo, insuranceLogo, insuranceLogoAltText, insuranceLogoClass,t } = this.props;
        let greetingText = '';
        let src = '';
        let lgSrc = '';
        let displayName = '';
        let mainClass = (containerClass ? containerClass : '') + (showCustomBanner ? " aal-lg-banner" : "");
        let baseColorClass = "";

        if (primaryUser) {
            displayName = getFirstName(primaryUser.displayName);
        }

        const thisStartDate = new Date();
        const thisUTCDate = new Date(Date.parse(thisStartDate.toUTCString()) - (dateTimeOffset * 60000));
        const hour = thisUTCDate.getUTCHours();

        if (hour < 12) {
            greetingText = 'Good morning,';
            src = '/images/morning-banner-sm.svg';
            lgSrc = '/images/morning-banner.svg';
            baseColorClass = "morning";
        }
        else if (hour < 18) {
            src = '/images/afternoon-banner-sm.svg';
            lgSrc = '/images/afternoon-banner.svg';
            baseColorClass = "afternoon";
            greetingText = 'Good afternoon,';
        }
        else {
            src = '/images/night-banner-sm.svg';
            lgSrc = '/images/night-banner.svg';
            baseColorClass = "evening";
            greetingText = 'Good evening,';
        }


        let bannerStyle = { opacity: this.props.opacity };
        let smBannerStyle = { backgroundImage: "url(" + src + ")" };
        let lgBannerStyle = { backgroundImage: "url(" + lgSrc + ")" };
        let greetingTextClass = isProxyUser || !insuranceLogo || insuranceLogoClass === "hidden-logo" ? " proxy-text" : "";

        const centerLogo = { alt: insuranceLogoAltText, src: insuranceLogo, class: insuranceLogoClass};

        return (
            <div className={"custom-graphics-banner" + mainClass + ' '  + versionBannerClass} style={bannerStyle}>
                <div className="" />
                <div className="" />
                <div className="greeting-center-container">
                    <div className="greeting-center">
                        <div className={"greeting-center-text" + greetingTextClass}>
                            <span className="header__greeting--welcome">{t(`Good ${baseColorClass}${displayName.length > 0 ? ', ' + displayName : ''}`)}</span>
                            <p>{ t("Welcome to your health hub")}</p>
                        </div>
                        {!isProxyUser && centerLogo &&
                            <div className={"greeting-center-logo " + centerLogo.class}>
                                <img alt={centerLogo.alt} src={centerLogo.src} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dateTimeOffset: state.domain.dto,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        hasMyChartLogin: state.domain.hm,
        isProxyUser: state.domain.ip,
        showCustomBanner: state.domain.sb,
        isEmployee: state.domain.ie,
        currentHealthPlanInfo: state.session.currentHealthPlanInfo,
        insuranceLogo: state.memberships.membershipBranding.insuranceLogo,
        insuranceLogoAltText: state.memberships.membershipBranding.insuranceLogoAltText,
        insuranceLogoClass: state.memberships.membershipBranding.insuranceLogoClass
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateShowBanner: () => dispatch({ type: types.GRAPHIC_BANNER_UPDATE })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomGraphicsBanner));